/**
 * Builds a usable product image URL.
 * Product JSON comes from the API host, but media files are served from the
 * Laravel admin host (admin.anuyog.co). Never use the public site origin for /media.
 */
export function resolveProductImage(image) {
  if (!image) {
    return '/images/default-product.jpg';
  }

  if (image.startsWith('http://') || image.startsWith('https://')) {
    return image;
  }

  // Prefer dedicated media host. Fall back to API host, then production admin.
  const mediaBase = (
    process.env.REACT_APP_MEDIA_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    'https://admin.anuyog.co'
  ).replace(/\/$/, '');

  let path = image.replace(/^\/+/, '');

  if (path.startsWith('storage/')) {
    return `${mediaBase}/${path}`;
  }

  if (!path.startsWith('media/')) {
    path = `media/${path}`;
  }

  return `${mediaBase}/${path}`;
}
